import { apiClient } from "./api_base";

export const fetchPatientMealInstances = async (params = {}) => {
  const response = await apiClient.get('/patient-meal-instances', { params });
  return response;
};

export const createPatientMealInstance = async (instanceData) => {
  const response = await apiClient.post('/patient-meal-instances', instanceData);
  return response;
};

export const fetchPatientMealInstanceById = async (id) => {
  const response = await apiClient.get(`/patient-meal-instances/${id}`);
  return response;
};

export const updatePatientMealInstance = async (id, instanceData) => {
  const response = await apiClient.put(`/patient-meal-instances/${id}`, instanceData);
  return response;
};

export const deletePatientMealInstance = async (id) => {
  const response = await apiClient.delete(`/patient-meal-instances/${id}`);
  return response;
};

export const addExtraComponent = async (instanceId, componentData) => {
  const response = await apiClient.post(`/patient-meal-instances/${instanceId}/extra-components`, componentData);
  return response;
};

export const updateExtraComponent = async (instanceId, componentId, componentData) => {
  const response = await apiClient.put(`/patient-meal-instances/${instanceId}/extra-components/${componentId}`, componentData);
  return response;
};

export const deleteExtraComponent = async (instanceId, componentId) => {
  const response = await apiClient.delete(`/patient-meal-instances/${instanceId}/extra-components/${componentId}`);
  return response;
};

